import { createApiAction, createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';
import * as generalApi from './../general/api';
import * as api from './api';

export const getTestTrends = createApiAction(
  types.GET_TEST_TRENDS,
  (payload) => generalApi.getTrends(payload).then(({ data }) => ({
    ...data,
    start: payload.start,
    end: payload.end,
  })),
);

export const getTestErrors = createApiAction(
  types.GET_TEST_ERRORS,
  (payload) => generalApi.getAggregatedTestErrors(payload),
);

export const getBuildsTests = createApiAction(
  types.GET_BUILDS_TESTS,
  (payload) => api.getBuildsTests(payload),
);

export const getTests = createApiAction(
  types.GET_TESTS,
  (payload) => api.getTests(payload),
);

export const getTestsByBuild = createApiAction(
  types.GET_TESTS_BY_BUILD,
  (payload) => api.getTests(payload),
);

export const setStatusFilter = createAction(types.SET_STATUS_FILTER);
export const setCurrentPage = createAction(types.SET_CURRENT_PAGE);
export const setTestsByBuild = createAction(types.SET_TESTS_BY_BUILD);
export const cleanup = createAction(types.CLEAN_UP);
